import { BeforeRoute } from "slot-definitions"
import { registerSystemAdminTab } from "routes/sfg20-admin/plugins/system-tab/register-system-admin-tab"
import { invalidate } from "lib/graphql/cache"
import { HubspotDisabledBanner } from "routes/sfg20-admin/plugins/system-tab/system-flags/hubspot-disabled-banner"
import { SystemFlagsPanel } from "routes/sfg20-admin/plugins/system-tab/system-flags/system-flags-panel"
import { SystemFlagsChanged } from "event-definitions"
import {
    PRIORITY_CONFIGURATION,
    SECTION_CONFIGURATION,
} from "routes/sfg20-admin/plugins/system-tab/system-admin-sections"

// Show a warning banner across the entire app when HubSpot is disabled
BeforeRoute.plug(<HubspotDisabledBanner $lazy priority={1} />)

// When a flag changes on any client the server broadcasts SystemFlagsChanged; refresh the
// cached flag queries everywhere so the app-wide banner updates without a manual reload.
SystemFlagsChanged.handleOnce(refreshSystemFlagQueries)

function refreshSystemFlagQueries() {
    invalidate("getSystemFlags")
    invalidate("isHubspotDisabled")
}

// Add System Flags page to System Admin
registerSystemAdminTab(
    "System Flags",
    <SystemFlagsPanel $lazy />,
    undefined,
    PRIORITY_CONFIGURATION + 10,
    "mdi:toggle-switch-outline",
    SECTION_CONFIGURATION
)
